const StandardPage = require('./Page');

module.exports = class TestTree extends StandardPage {
    constructor(title, properties, namespaces) {
        super(title, properties, namespaces, 'page_NavigationSelectedContextPage');
    }
    //anything that can go in a standard Page can go into this page.
};
